/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateKnowledgeBaseRequest } from '../models/CreateKnowledgeBaseRequest';
import type { CreateKnowledgeBaseResponse } from '../models/CreateKnowledgeBaseResponse';
import type { KnowledgeBaseResult } from '../models/KnowledgeBaseResult';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class KnowledgeBaseService {

    /**
     * Create a new upload.
     * @param requestBody The request to create an upload.
     * @returns CreateKnowledgeBaseResponse OK
     * @throws ApiError
     */
    public static createKnowledgeBase(
        requestBody?: CreateKnowledgeBaseRequest,
    ): CancelablePromise<CreateKnowledgeBaseResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/knowledgebases/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Create a new upload.
     * @param knowledgeBaseId The request to create an upload.
     * @returns any OK
     * @throws ApiError
     */
    public static deleteKnowledgeBase(
        knowledgeBaseId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/knowledgebases/{knowledgeBaseId}/delete',
            path: {
                'knowledgeBaseId': knowledgeBaseId,
            },
        });
    }

    /**
     * Retrieve all projects for the specified workspace, excluding those created via the external API.
     * @param organizationId The ID of the workspace to scope the projects for.
     * @returns KnowledgeBaseResult OK
     * @throws ApiError
     */
    public static getKnowledgeBases(
        organizationId: string,
    ): CancelablePromise<Array<KnowledgeBaseResult>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/knowledgebases/{organizationId}',
            path: {
                'organizationId': organizationId,
            },
        });
    }

}
